"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarSize = exports.avatarUserStatus = exports.avatar = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var avatar = {
  size3xsmall: '16px',
  size2xsmall: '24px',
  sizeXsmall: '32px',
  sizeSmall: '40px',
  sizeMedium: '48px',
  sizeLarge: '64px',
  sizeXlarge: '72px',
  size2xlarge: '80px',
  size3xlarge: '160px',
  font3xsmall: '7px',
  font2xsmall: '10px',
  fontXsmall: '12px',
  fontSmall: '13px',
  fontMedium: '15px',
  fontLarge: '15px',
  fontXlarge: '19px',
  font2xlarge: '19px',
  font3xlarge: '36px',
  icon3xsmall: 10,
  icon2xsmall: 14,
  iconXsmall: 19,
  iconSmall: 24,
  iconMedium: 28,
  iconLarge: 38,
  iconXlarge: 44,
  icon2xlarge: 44,
  icon3xlarge: 76,
  avatarBackgroundColor: _color["default"].cloudyBlue,
  initialsColor: _color["default"].pickledBluewood800,
  initialsFontFamily: _font["default"].family,
  placeholderIconColor: _color["default"].steel700,
  editOverlayColor: _color["default"].steel700,
  editIconColor: _color["default"].white,
  editIconSmallSize: _size["default"].default2x,
  editIconLargeSize: _size["default"].medium
};
exports.avatar = avatar;
var avatarSize = {
  size3xsmall: '3xsmall',
  size2xsmall: '2xsmall',
  sizeXsmall: 'xsmall',
  sizeSmall: 'small',
  sizeMedium: 'medium',
  sizeLarge: 'large',
  sizeXlarge: 'xlarge',
  size2xlarge: '2xlarge',
  size3xlarge: '3xlarge'
};
exports.avatarSize = avatarSize;
var avatarUserStatus = {
  available: 'available',
  away: 'away',
  busy: 'busy',
  doNotDisturb: 'doNotDisturb',
  onBreak: 'onBreak',
  onCall: 'onCall',
  offline: 'offline',
  workingOffline: 'workingOffline'
};
exports.avatarUserStatus = avatarUserStatus;